import type { FC } from 'react';

import cx from 'classnames';

interface CopyIconProps {
  className?: string;
  fill?: string;
}

const CopyIcon: FC<CopyIconProps> = ({ className, fill }) => {
  return (
    <svg className={cx(className)} viewBox="0 0 20 20" fill={fill ?? 'none'} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.125 13.125H16.25V3.75H6.875V6.875"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 6.875H3.75V16.25H13.125V6.875Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CopyIcon;
